import { Trophy } from "lucide-react";

export const TeamBannerHeader = ({ broadcast, isLive, isCompleted, isNotStarted, liveScore }) => {
  const homeTeam = typeof broadcast.home_team === 'object' ? broadcast.home_team : { name: broadcast.home_team };
  const awayTeam = typeof broadcast.away_team === 'object' ? broadcast.away_team : { name: broadcast.away_team };

  const homeScore = liveScore?.home_score ?? broadcast.final_home_score;
  const awayScore = liveScore?.away_score ?? broadcast.final_away_score;

  const formatGameTime = () => {
    if (!broadcast.scheduled_date) return "TBD";
    const date = new Date(`${broadcast.scheduled_date}T${broadcast.scheduled_time || "00:00"}`);
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-gradient-to-b from-zinc-900 to-zinc-950 border-b border-white/10 overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 py-6">
        <div className="flex items-center justify-between gap-2 md:gap-4">
          {/* Away Team */}
          <div className="flex-1 flex items-center gap-2 md:gap-4 min-w-0">
            <div
              className="w-12 h-12 md:w-20 md:h-20 rounded-full bg-zinc-800 flex items-center justify-center p-1.5 md:p-2 flex-shrink-0 overflow-hidden"
              style={{ borderColor: awayTeam?.color || '#333', borderWidth: '3px' }}
            >
              {awayTeam?.logo_url ? (
                <img src={awayTeam.logo_url} alt={awayTeam.name} className="w-8 h-8 md:w-14 md:h-14 object-contain" />
              ) : (
                <span className="text-white font-bold text-sm md:text-xl">{awayTeam?.name?.charAt(0) || 'A'}</span>
              )}
            </div>
            <div className="min-w-0">
              <p className="text-white/60 text-[10px] md:text-xs uppercase tracking-wider mb-0.5 md:mb-1">Away</p>
              <h2 className="text-white font-bold text-sm md:text-xl uppercase tracking-tight truncate">
                {awayTeam?.name || 'TBD'}
              </h2>
              {awayTeam?.mascot && (
                <p className="text-white/50 text-sm hidden md:block">{awayTeam.mascot}</p>
              )}
            </div>
            {(isLive || isCompleted) && awayScore !== null && awayScore !== undefined && (
              <p className={`text-2xl md:text-5xl font-black ml-auto flex-shrink-0 ${
                isLive ? 'text-white' : awayScore > homeScore ? 'text-green-400' : 'text-white/60'
              }`}>
                {awayScore}
              </p>
            )}
          </div>

          {/* Center - Status Badge */}
          <div className="flex flex-col items-center px-2 md:px-4 flex-shrink-0">
            {isLive ? (
              <span className="px-2 md:px-4 py-1.5 md:py-2 bg-red-600 text-white text-xs md:text-sm font-black uppercase rounded animate-pulse flex items-center gap-1.5">
                <span className="w-2 h-2 bg-white rounded-full"></span>
                LIVE
              </span>
            ) : isCompleted ? (
              <span className="px-2 md:px-4 py-1.5 md:py-2 bg-zinc-700 text-white text-xs md:text-sm font-bold uppercase rounded">
                FINAL
              </span>
            ) : (
              <div className="text-center">
                <p className="text-zinc-400 text-[10px] md:text-xs uppercase mb-0.5 md:mb-1">Game Time</p>
                <p className="text-white font-bold text-xs md:text-sm">{formatGameTime()}</p>
              </div>
            )}
            {liveScore?.period && isLive && (
              <p className="text-zinc-400 text-[10px] md:text-xs mt-1">{liveScore.period}</p>
            )}
          </div>

          {/* Home Team */}
          <div className="flex-1 flex items-center gap-2 md:gap-4 justify-end min-w-0">
            {(isLive || isCompleted) && homeScore !== null && homeScore !== undefined && (
              <p className={`text-2xl md:text-5xl font-black mr-auto flex-shrink-0 ${
                isLive ? 'text-white' : homeScore > awayScore ? 'text-green-400' : 'text-white/60'
              }`}>
                {homeScore}
              </p>
            )}
            <div className="text-right min-w-0">
              <p className="text-white/60 text-[10px] md:text-xs uppercase tracking-wider mb-0.5 md:mb-1">Home</p>
              <h2 className="text-white font-bold text-sm md:text-xl uppercase tracking-tight truncate">
                {homeTeam?.name || 'TBD'}
              </h2>
              {homeTeam?.mascot && (
                <p className="text-white/50 text-sm hidden md:block">{homeTeam.mascot}</p>
              )}
            </div>
            <div
              className="w-12 h-12 md:w-20 md:h-20 rounded-full bg-zinc-800 flex items-center justify-center p-1.5 md:p-2 flex-shrink-0 overflow-hidden"
              style={{ borderColor: homeTeam?.color || '#333', borderWidth: '3px' }}
            >
              {homeTeam?.logo_url ? (
                <img src={homeTeam.logo_url} alt={homeTeam.name} className="w-8 h-8 md:w-14 md:h-14 object-contain" />
              ) : (
                <span className="text-white font-bold text-sm md:text-xl">{homeTeam?.name?.charAt(0) || 'H'}</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
